export const ACTION_PAYLOAD_TYPE_ID = 13;
export const ACTIONPLAN_PAYLOAD_TYPE_ID = 12;
export const REQUEST_PAYLOAD_TYPE_ID = 3;
export const COM_P1_ORIGIN_ID = 4;
